export class UserAttendance
{
    attendanceEvent:
        {
        title:string;
        color:string,
        dates: 
          {
            start:Date;
            end:Date;
            comment:string;
          }[],
        }[]
}